module.exports = __webpack_public_path__ + "img/medal_vip4.1a6dc45.png";